module.exports = {
    props: ['team'],

    /**
     * The component's data.
     */
    data() {
        return {
            form: $.extend(true, new SparkForm({
                main_frontend_lookup_provider: '',
                main_backend_lookup_provider: '',
            }), Spark.forms.updateGoogleSearchProviderSettings)
        };
    },


    /**
     * Bootstrap the component.
     */
    mounted() {
        this.form.main_frontend_lookup_provider = this.team.main_frontend_lookup_provider || '';
        this.form.main_backend_lookup_provider = this.team.main_backend_lookup_provider || '';
    },


    methods: {
        /**
         * Update the user's contact information.
         */
        update() {
            Spark.put(`/settings/${Spark.teamsPrefix}/${this.team.id}/google-search-provider-settings`, this.form)
                .then(() => {
                    Bus.$emit('updateTeam');
                });
        }
    }
};
